import React, { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import ErrorMessage from "../ErrorMessage";

// setup default function that returns a promise
// so apps that use this component don't have to pass
// along a submit api call if they don't want to
const defaultPromise = () => {
    const fakePromise = new Promise((resolve, reject) => {
        const pass = true;
        if (pass) {
            resolve();
        } else {
            reject();
        }
    });
    return fakePromise;
};

/**
 *
 * @param {object} props
 * @param {object} [props.additionalSubmitErrorData] Leaving this type flexible
 * ensures we can send any additional data to Slack.
 * @param {string} [props.additionalText]
 * @param {boolean} [props.dark]
 * @param {string} [props.headingText]
 * @param {() => void} [props.removeSessionStorage]
 * @param {(object) => any} [props.submitErrorData]
 * @returns {React.ReactElement}
 */
const SimpleErrorDisplay = ({
    additionalSubmitErrorData = {},
    additionalText = "Contact the organization for support.",
    dark = false,
    headingText = "We're sorry, it looks like something went wrong.",
    removeSessionStorage = () => {},
    submitErrorData = defaultPromise,
}) => {
    const location = window.location.href;
    const { message, stack } = useRouteError();

    useEffect(() => {
        // remove session data if exists because it may be that loading that stored data was
        // what was causing the crash and we don't want to repeat that process.
        removeSessionStorage();
        submitErrorData({
            data: {
                location,
                message,
                stack,
                ...additionalSubmitErrorData,
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return (
        <ErrorMessage
            additionalText={additionalText}
            dark={dark}
            headingText={headingText}
        />
    );
};

export default SimpleErrorDisplay;
